import commonService from './common-service';

class FacilityService {

  async getFacilities() {
    try {
      const response = await commonService.getFromServer('Facilities', {});
      if (response) {
        return response;
      } else {
        throw new Error('Error retrieving facilities. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getAccessForFacilities(facId) {
    try {
      const response = await commonService.getFromServer('Remote/Access/'+facId, {});
      if (response) {
        return response;
      } else {
        throw new Error('Error retrieving data. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getFacilityById(uid) {
    try {
      const response = await commonService.getFromServer('Facilities/ByUser/'+uid, {});
      if (response) {
        return response;
      } else {
        throw new Error('Error retrieving facilities. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getFacilityNameById(fid) {
    try {
      const response = await commonService.getFromServer('Facilities/'+fid, {});
      if (response) {
        return response;
      } else {
        throw new Error('Error retrieving facilities. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
}

export default new FacilityService();
